import * as React from "react";
import { Linking, ScrollView, StyleSheet } from "react-native";
import { Block } from "@block";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { StackActions, useNavigation } from "@react-navigation/native";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import { StackSpacing } from "@components/spacing";
import { useTranslation } from "react-i18next";
import { StepProcessUniversal } from "app/shared/components/stepper-process/stepper-process";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { ButtonFormActions, ButtonRow, HeaderSuccessTitle, RowInputColumn } from "app/shared/components/screen-success/screen-success";
import { useDispatch, useSelector } from "react-redux";
import ScreenNameType from "@navigation/nav-screens";
import { getTermDepositOpenSelector } from "../reducer/selectors";
import { formatTextTerm, getTermDepositProductName } from "../../term-deposit-utils/term-deposit.utils";
import moment from "moment";
import GlobalViewShot, { GlobalViewShotRef } from "app/shared/components/global-view-shot/global-viewshot.web";
import { fetchListAccountRequest } from "app/modules/account-management/reducer/actions";
import { showModal } from "app/modules/modal-management/reducer/action";
import { Paragraph, useTheme } from "react-native-paper";
import { formatCurrency } from "app/shared/util/format-currency";
import { fetchTermDepositPromotionsRequest } from "../reducer/actions";
import { pushCleverTapEvent } from "app/shared/util/app-flyer";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";

const TYPE_DIALOG = {
  QUESTIONS: "1",
  ACCEPT: "2",
};

// const TermsLink = "https://mb25mfatest.pvcombank.com.vn/files/DieuKhoan/ChuongTrinhKhuyenMai.html"; // UAT
const TermsLink = "https://mbanking255.pvcombank.com.vn/files/DieuKhoan/ChuongTrinhKhuyenMai.html"; // Prod

const TermDepositOpenSuccess = () => {
  const { dispatch } = useNavigation();
  const { t } = useTranslation();
  const { colors, fonts } = useTheme();
  const dispatchStore = useDispatch();
  const isDesktop = useDesktopMediaQuery();
  const globalViewShotRef = React.useRef<GlobalViewShotRef>(null);

  const termDepositsStore = useSelector(getTermDepositOpenSelector);
  const contactId = useSelector(getContactIdSelector);

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        txtUnderline: { color: colors.accent, textDecorationLine: "underline" },
        textStyle: {
          textAlign: "center",
        },
        messageStyle: {
          color: colors.blackText,
          letterSpacing: 0,
          textAlign: "center",
          ...fonts.regular,
        },
        subContentStyle:{
          fontStyle: "italic",
        }
      }),
    [colors.accent, colors.blackText, fonts.regular],
  );

  const onPressGoHome = () => {
    //In biên lai | Tải về | Trang chủ | Giao dịch khác
    eventPushCleverTap("Trang chủ");
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const onPressGoBack = () => {
    eventPushCleverTap("Giao dịch khác");
    dispatch(StackActions.replace(ScreenNameType.LIST_FUNCTION_TERM_DEPOSIT));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => onPressGoHome(),
    },
    {
      name: t("FUNC_TIET_KIEM"),
      onPressSubtitle: () => onPressGoBack(),
    },
    {
      name: t("SAVING_MO_SO"),
      onPressSubtitle: () => {},
    },
  ];

  const eventPushCleverTap = (action?: string) => {
    const { eventNameCT, paramsCT } = handlerParamsCleverTap(action);
    pushCleverTapEvent(eventNameCT, paramsCT);
  };

  const onPressPrint = () => {
    eventPushCleverTap("In biên lai");
    globalViewShotRef.current?.printViewShot();
  };

  const onPressShare = () => {
    eventPushCleverTap("Tải về");
    globalViewShotRef.current?.takeViewShot();
  };

  const handlerAcceptDialog = () => {
    dispatchStore(fetchTermDepositPromotionsRequest(termDepositsStore.responseAuth));
  };

  const handlerParamsCleverTap = (cta?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_cta: cta || "",
      ct_create_deposit_product: termDepositsStore.dataCreate?.PRODUCT?.value,
      ct_create_deposit_term: (termDepositsStore.dataCreate?.TERM?.value || "") + termDepositsStore.dataCreate?.TERM?.label,
      ct_create_deposit_amount: termDepositsStore.dataCreate?.AMOUNT,
      ct_create_deposit_maturity: termDepositsStore.dataCreate?.MATURITY?.value,
      ct_create_deposit_branch: termDepositsStore.dataCreate?.BRANCH?.value,
      ct_transaction_session: termDepositsStore.responseConfirm?.EBACCOUNT_DEPOSITS?.RQSTSEQ || "",
      ct_transaction_code: termDepositsStore.responseConfirm?.CHALLENGE_ID || "",
      ct_transaction_time:
        moment(String(termDepositsStore.responseAuth?.EBACCOUNT_DEPOSITS?.OPEN_DATE), "YYYYMMDD").format("DD/MM/YYYY") || "",
      ct_create_deposit_status: "success",
    };

    return {
      eventNameCT: "ct_create_deposit_success",
      paramsCT: param,
    };
  };

  const showDialogPromotion = React.useCallback((type: string, value?: string) => {
    let dialogMessage: string = "";
    if (type === TYPE_DIALOG.QUESTIONS) {
      let content = (
        <Paragraph>
          <Paragraph style={styles.messageStyle}>
            {
              t("SAVING_PROMOTION_CONTENT").replace("{event_name}", '"' + t("SAVING_PROMOTION_EVENT_NAME") + '"')
              // .replace("{amount}", amountMaxPromotions)
            }
          </Paragraph>
          <Paragraph style={[styles.messageStyle,styles.subContentStyle]}>{'\n' + t("SAVING_PROMOTION_SUB_CONTENT")}</Paragraph>
          <Paragraph style={styles.messageStyle}>{'\n' + t("SAVING_PROMOTION_EVENT_MORE_INFO")}</Paragraph>
          <Paragraph
            onPress={() => {
              Linking.openURL(TermsLink);
            }}
            style={styles.txtUnderline}>
            {" " + t("SAVING_PROMOTION_EVENT_HERE")}
          </Paragraph>
        </Paragraph>
      );
      dispatchStore(
        showModal({
          modalType: "multiAction",
          modalProps: {
            open: true,
            title: t('SAVING_PROMOTION_EVENT_NAME'),
            message: dialogMessage,
            content: content,
            titleBtnAccept: t("SAVING_PROMOTION_ACTION_AGREE"),
            titleBtnCancel: t("SAVING_PROMOTION_ACTION_NOT_AGREE"),
            acceptModal: handlerAcceptDialog,
          },
        }),
      );
    } else if (type === TYPE_DIALOG.ACCEPT && value) {
      const cashback = formatCurrency(value, "VND");
      dialogMessage = t("SAVING_PROMOTION_APPLY_SUCCESS_AMOUNT").replace("{amount}", cashback);
      dispatchStore(
        showModal({
          modalType: "alert",
          modalProps: {
            open: true,
            message: dialogMessage,
          },
        }),
      );
      dispatchStore(fetchListAccountRequest());
    } else if (type === TYPE_DIALOG.ACCEPT) {
      dialogMessage = t("SAVING_PROMOTION_APPLY_SUCCESS");
      dispatchStore(
        showModal({
          modalType: "alert",
          modalProps: {
            open: true,
            message: dialogMessage,
          },
        }),
      );
      dispatchStore(fetchListAccountRequest());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlerCheckPromotion = React.useCallback(() => {
    const promotion = termDepositsStore.responseAuth?.EBACCOUNT_DEPOSITS?.PROMOTIONS;
    if (promotion && promotion === "Y") {
      showDialogPromotion(TYPE_DIALOG.QUESTIONS);
    }
  }, [showDialogPromotion, termDepositsStore.responseAuth]);

  const FormSuccess = (
    <Block center p={spacing.large}>
      <RowInputColumn name={t("SAVING_SO_TIET_KIEM")} value={termDepositsStore.responseAuth?.EBACCOUNT_DEPOSITS?.CREDIT_ACCOUNT_NUMBER} />
      <RowInputColumn
        name={t("SAVING_TEN_NGUOI_THU_HUONG")}
        value={termDepositsStore.responseAuth?.EBACCOUNT_DEPOSITS?.CREDIT_ACCOUNT_NAME}
      />
      <RowInputColumn name={t("SAVING_SAN_PHAM")} value={getTermDepositProductName(termDepositsStore.dataCreate?.PRODUCT?.value)} />
      <RowInputColumn
        name={t("SAVING_KY_HAN")}
        value={formatTextTerm(termDepositsStore.dataCreate?.TERM?.value, termDepositsStore.dataCreate?.TERM?.label)}
      />
      <RowInputColumn
        name={t("SAVING_NGAY_DEN_HAN")}
        value={moment(String(termDepositsStore.responseAuth?.EBACCOUNT_DEPOSITS?.MATURITY_DATE), "YYYYMMDD").format("DD/MM/YYYY")}
      />
    </Block>
  );

  React.useEffect(() => {
    handlerCheckPromotion();
  }, [handlerCheckPromotion]);

  React.useEffect(() => {
    eventPushCleverTap();
    dispatchStore(fetchListAccountRequest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchStore]);

  React.useEffect(() => {
    if (termDepositsStore.resPromotions) {
      const amount = termDepositsStore.resPromotions?.EBACCOUNT_DEPOSITS?.CASHBACK_AMOUNT;
      if (amount) {
        showDialogPromotion(TYPE_DIALOG.ACCEPT, amount);
      }
      else {
        showDialogPromotion(TYPE_DIALOG.ACCEPT);
      }
    }
  }, [showDialogPromotion, termDepositsStore.resPromotions]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("SAVING_MO_SO")} subtitles={subtitlesArrays} />
        <Block pv={spacing.huge} ph={isDesktop ? 150 : 0}>
          <StepProcessUniversal currentSteps={3} />
          <StackSpacing size="medium" />
          <GlobalViewShot ref={globalViewShotRef}>
            <HeaderSuccessTitle amount={termDepositsStore.dataCreate?.AMOUNT} />
            {FormSuccess}
          </GlobalViewShot>
          <ButtonFormActions onPressPrint={onPressPrint} onPressShare={onPressShare} />
          <ButtonRow onPressGoBack={onPressGoBack} onPressGoHome={onPressGoHome} />
        </Block>
      </ScrollView>
    </Block>
  );
};

export default TermDepositOpenSuccess;
